import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Icon5 from "../../assest/images/Icon5.png";
import StatusCustomDropdown from '../common/StatusCustomDropdown';
import CustomSingleValue from '../common/CustomSingleValue';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';

const RM = () => {
  const [routeName, setRouteName] = useState('');
  const [status, setStatus] = useState('1');
  const [scpName, setScpName] = useState('');
  const [scpNamesList, setScpNamesList] = useState([]);
  const [routeDetails, setRouteDetails] = useState([]);
  const [initialState, setInitialState] = useState({});
  const [loading, setLoading] = useState(false);
  const [emptyFields, setEmptyFields] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [suspendConfirmationModal, setSuspendConfirmationModal] = useState(false);
  const [scpToDelete, setScpToDelete] = useState(null);
  const [deletedSCPName, setDeletedSCPName] = useState('');

  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };


  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);
  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
  useEffect(() => {
    fetchScpNames();
    setInitialState({
      routeName: '',
      status: '1',
      scpName: '',
      routeDetails: [],
    });
  }, [selectedScpId]);

  const fetchScpNames = (scpId) => {

    fetch(`${config.API_URL}/routing_master/scpcode/${selectedScpId}`)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log('SCP data for Select fetched successfully:', data.scpData);
          setScpNamesList(
            data.scpData.map(scp => ({
              label: scp.name,
              value: scp.id
            }))
          );
        } else {
          console.error('Failed to fetch SCP Names for Select:', data.message);
        }
      })
      .catch(error => {
        console.error('Error fetching SCP Names for Select:', error);
        logAction(`fetchScpNamesForSelect():Error fetching SCP Names for Select for Route ${scpId}: ${error.message}`, true);
      })
      .finally(() => {
        logAction('fetchScpNamesForSelect():ended');
      });
  };

  const addSCP = () => {
    let emptyFieldsArray = [];

    if (routeName === '') {
      emptyFieldsArray.push('routeName');
    }

    if (status === '' || status === 'Select Status') {
      emptyFieldsArray.push('status');
    }

    if (!scpName) {
      emptyFieldsArray.push('scpName');
    }

    if (emptyFieldsArray.length > 0) {
      setEmptyFields(emptyFieldsArray);
      return;
    }

    setEmptyFields([]);

    // Find the selected SCP object to get both ID and name
    const selectedScp = scpNamesList.find(option => option.value === scpName);
    if (!selectedScp) {
      //toast.error('Selected SCP is invalid.');
      logAction(`addSCP():ended with error Invalid SCP selected: ${scpName}`, true);
      return;
    }

    // Check for duplicate SCP name
    const duplicateRecord = routeDetails.find(
      (detail) => detail.scpName === selectedScp.label
    );
    if (duplicateRecord) {
      showToast('error', `SCP Name: ${selectedScp.label} is already added.`);
      logAction(`addSCP():ended with error, Duplicate record found: ${routeName} - ${selectedScp.label}`, true);
      return;
    }

    // Add both SCP ID and name to routeDetails
    setRouteDetails([...routeDetails, {
      scpId: scpName,
      scpName: selectedScp.label,
      routeName
    }]);

    setScpName(''); // Reset the SCP selection

    logAction(`addSCP():ended and Added SCP: ${selectedScp.label} for Route: ${routeName}`);
  };

  const deleteSCP = () => {
    if (scpToDelete !== null) {
      const deletedSCP = routeDetails[scpToDelete].scpName;
      const updatedRouteDetails = [...routeDetails];
      updatedRouteDetails.splice(scpToDelete, 1);
      setRouteDetails(updatedRouteDetails);
      logAction(`deleteSCP():ended Deleted SCP: ${deletedSCP}`);
      handleCloseModal();
      //toast.success(`SCP : ${deletedSCP} removed successfully`);
    }
  };

  const openSuspendModal = (index) => {
    setScpToDelete(index);
    setDeletedSCPName(routeDetails[index].scpName);
    setSuspendConfirmationModal(true);
  };

  const handleCloseModal = () => {
    setSuspendConfirmationModal(false);
    setScpToDelete(null);
    setDeletedSCPName('');
  };


  const saveRoute = () => {
    setLoading(true);
    const rawRouteName = routeName || '';
    const trimmedRouteName = rawRouteName.trim();

    let emptyFieldsArray = [];

    if (trimmedRouteName === '') {
      emptyFieldsArray.push('routeName');
    }

    if (status === '' || status === 'Select Status') {
      emptyFieldsArray.push('status');
    }

    if (emptyFieldsArray.length > 0) {
      setEmptyFields(emptyFieldsArray);
      setLoading(false);
      return;
    }

    if (/^\s/.test(rawRouteName)) {
      setErrorMessage('First character must not be a space');
      setLoading(false);
      return;
    }

    if (!routeDetails.length > 0) {
      showToast('error', `At least one SCP is required to save the Route.`);
      setLoading(false);
      return;
    }

    setEmptyFields([]);

    const alphanumericRegex = /^[a-zA-Z0-9]+(?:[ _-][a-zA-Z0-9]+)*$/;
    const startsWithAlphanumeric = /^[a-zA-Z0-9]/;
    const startsWithAlphabets = /^[a-zA-Z0-9]/;
    const endsWithAlphanumeric = /[a-zA-Z0-9]$/;

    const validRouteName =
      alphanumericRegex.test(trimmedRouteName) &&
      startsWithAlphanumeric.test(trimmedRouteName) &&
      startsWithAlphabets.test(trimmedRouteName) &&
      endsWithAlphanumeric.test(trimmedRouteName);

    if (!validRouteName) {
      logAction(`addSCP():ended with error Invalid route name: ${trimmedRouteName}`, true);
      setLoading(false);
      return;
    }
    else if (trimmedRouteName.length > 45) {
      logAction(`addSCP():ended with error Route name length exceeds 45 characters: ${trimmedRouteName}`, true);
      setLoading(false);
      return;
    }

    if (status === '' || status === 'Select Status') {
      logAction(`addSCP():ended with error Invalid status: ${status}`, true);
      setLoading(false);
      return;
    }

    fetch(`${config.API_URL}/routing_master/checkDuplicates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        RUTL_Name: trimmedRouteName,
        RUTL_Status: parseInt(status),
        scpDetails: routeDetails.map((detail) => detail.scpId),
        UM_CompanyGrpID: UM_CompanyGrpID,
        RUTL_CompanyID: UM_CompanyID,
        RUTL_CreatedBy: UM_UserId,
        RUTL_SCPID: selectedScpId,
      }),
    })
      .then(response => response.json())
      .then((data) => {

        if (data.duplicateExists) {
          showToast('error', `Route : ${trimmedRouteName} already exists.`);
          logAction('saveRoute(): ended with error- Duplicate record found', true);
          setLoading(false);
          return;
        }

        const saveData = {
          RUTL_Name: String(trimmedRouteName),
          RUTL_Status: parseInt(status),
          scpDetails: routeDetails.map((detail) => detail.scpId),
          RUTL_CompanyGrpID: UM_CompanyGrpID,
          RUTL_CompanyID: UM_CompanyID,
          RUTL_CreatedBy: UM_UserId,
          RUTL_SCPID: selectedScpId,
        };

        const currentRouteStatus = parseInt(status) === 1 ? 'Active' : 'Inactive';

        const transactionDetails = [
          {
            AUTRN_ParamererName: "Route Name",
            AUTRN_OldValue: "-",
            AUTRN_NewValue: String(trimmedRouteName)
          },
          {
            AUTRN_ParamererName: "Status",
            AUTRN_OldValue: "-",
            AUTRN_NewValue: currentRouteStatus
          },
          {
            AUTRN_ParamererName: "Route Details",
            AUTRN_OldValue: "-",
            AUTRN_NewValue: JSON.stringify(
              routeDetails.map((row, index) => ({
                "Sr. No.": index + 1,
                "SCP Name": row.scpName
              }))
            )
          }
        ];

        logAudit(
          "Route Master",
          `Route : ${String(trimmedRouteName)} saved successfully`,
          '-',
          `${String(trimmedRouteName)}`,
          transactionDetails
        );

        fetch(`${config.API_URL}/routing_master/insertData`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(saveData),
        })
          .then((response) => response.text())
          .then((result) => {
            console.log(result);
            toast.success(`Route : ${String(trimmedRouteName)} saved successfully.`, {
              onClose: () => {
                resetForm();
                setLoading(false);
              }
            });
            logAction('saveRoute():ended');
            logAction('saveRoute():ended and data saved successfully');

          })
          .catch((error) => {
            console.error('Error saving route:', error);
            logAction('saveRoute():ended with error', true, error.message || 'Unknown error');
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error('Error checking duplicates:', error);
        logAction('saveRoute():ended with error of duplicate data', true, error.message || 'Unknown error');
        setLoading(false);
      });
  };

  const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 13,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
      transactionDetails // Array of transaction details to be inserted into audittransaction
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const logAction = async (action, isError = false) => {
    console.log(`${isError ? '[ERROR] ' : ''}${action}`);
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Route-Master:", action, userCode: UM_UserCode, isError }),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const resetForm = () => {
    setRouteName('');
    setErrorMessage('');
    setStatus('1');
    setScpName('');
    setRouteDetails([]);

    setEmptyFields([]);

    logAction('Form is reset by user');
  };

  const validateRouteName = (value) => {
    if (!value || value.trim() === '') return '';
    const validationValue = value.replace(/\s+$/, '');

    if (validationValue.length > 45) {
      return 'Route Name length cannot be more than 45';
    }

    // First & last must be alphanumeric (ignore single char case)
    if (
      validationValue.length > 1 &&
      (!/^[A-Za-z0-9]/.test(validationValue) || !/[A-Za-z0-9]$/.test(validationValue))
    ) {
      return 'First and last characters must be alphanumeric';
    }

    // No consecutive special characters
    if (/[\-_. ]{2,}/.test(value)) {
      return 'Consecutive special characters are not allowed';
    }

    return '';
  };


  const handleRouteNameChange = (e) => {
    let inputValue = e.target.value;

    // ✅ Allow only alphanumeric, space, underscore, hyphen
    // Remove invalid characters silently
    inputValue = inputValue.replace(/[^A-Za-z0-9 _-]/g, '');
    inputValue = inputValue.replace(/[\s_-]{2,}/g, (match) => match[0]);

    // ✅ Enforce max length while typing
    if (inputValue.length > 45) {
      inputValue = inputValue.slice(0, 45);
    }

    setRouteName(inputValue);
    if (inputValue.trim() !== '') {
      setEmptyFields(prev => prev.filter(f => f !== 'routeName'));
    }

    // ✅ Now run validation only on cleaned value
    const errorMessage = validateRouteName(inputValue);
    setErrorMessage(errorMessage);
  };


  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  return (
    <>
      {loading && (
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          zIndex: 1000
        }} />
      )}
      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />
      <div className='main_container'>
        <h2 className='formHeading'>Route Master</h2>

        <div className='row'>
          {/* <div className='form-section'> */}
          <div className="col-md-6">


            <Form.Group className="mb-3" autoComplete="off">
              <label>Route Name{emptyFields.includes('routeName') && <span style={{ color: 'red' }}> *</span>}</label>
              <input
                type="text"
                className='form-input'
                value={routeName}
                onChange={handleRouteNameChange}
                placeholder="Enter Route Name"
              />
              {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-3" autoComplete="off">
              <label>
                Status
                {emptyFields.includes('status') && <span style={{ color: 'red' }}> *</span>}
              </label>

              <div className='select-container'>
                <Select
                  className="routing_select-box"
                  options={[
                    { value: 1, label: 'Active' },
                    { value: 2, label: 'Inactive' },
                  ]}
                  value={
                    [
                      { value: 1, label: 'Active' },
                      { value: 2, label: 'Inactive' },
                    ].find(opt => opt.value === (status || 1)) || { value: 1, label: 'Active' }
                  }
                  onChange={(option) => {
                    setStatus(option ? option.value : 1);  // fallback to 1 if somehow cleared
                  }}
                  // No placeholder → forces selection of one of the options
                  // (react-select will show the selected value instead)
                  onMenuOpen={() => handleSelectOpen('GRPM_GroupStatus')}
                  onMenuClose={handleSelectClose}
                  maxMenuHeight={140}
                  isSearchable={false}
                  components={{ SingleValue: CustomSingleValue }}
                />

                <div className="icon-container_list myList">
                  <i>
                    {isSelectOpen === 'GRPM_GroupStatus' ? (
                      <IoCaretUpOutline />
                    ) : (
                      <IoCaretDownOutline />
                    )}
                  </i>
                </div>
              </div>
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-3" autoComplete="off">
              <label>SCP Name{emptyFields.includes('scpName') && <span style={{ color: 'red' }}> *</span>}</label>
              <div className='select-container'>
                <Select
                  className='routing_select-box'
                  options={scpNamesList.map(option => ({
                    ...option,
                    isDisabled: routeDetails.some(detail => detail.scpId === option.value)
                  }))}
                  value={scpNamesList.find(option => option.value === scpName) || null}
                  onChange={(selectedOption) => {
                    const value = selectedOption ? selectedOption.value : null;
                    setScpName(value);

                    // ✅ Remove asterisk immediately on selection
                    if (value) {
                      setEmptyFields(prev => prev.filter(f => f !== 'scpName'));
                    }
                  }}
                  placeholder="--Select--"
                  maxMenuHeight={160}
                  onMenuOpen={() => handleSelectOpen('scpName')}
                  onMenuClose={handleSelectClose}
                  components={{ SingleValue: CustomSingleValue }}

                />
                <div className='icon-container'>
                  {isSelectOpen === 'scpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                </div>

              </div>
            </Form.Group>
          </div>
          <div className="col-md-6 mb-3">
            <button type="button" className='add_btn ' onClick={addSCP} style={{ fontWeight: 'bold', width: "200px" }}>ADD</button>
          </div>
          {/* </div> */}
        </div>

        <div>
          {routeDetails.length > 0 && (
            <table className='tableClass'>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>SCP Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {routeDetails.map((detail, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{detail.scpName}</td> {/* Display SCP name instead of ID */}
                    <td>
                      <img
                        src={Icon5}
                        title='Remove'
                        alt="suspendremovebg"
                        className="delete_btn"
                        style={{ cursor: 'pointer' }}
                        onClick={() => openSuspendModal(index)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

      </div>
      <div className="button-container">
        <button className="save_btn"
          onClick={saveRoute} >
          SAVE
        </button>
        <button className="reset_btn"
          onClick={resetForm}>
          RESET
        </button>
        <Link to={`/rmlist`}
          className='  list_btn' type='button' >LIST
        </Link>
      </div>

      {suspendConfirmationModal && (
        <div className="popup_overlay" style={{
          backdropFilter: 'blur(3px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        }}>
          <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>Are you sure you want to remove this SCP : {deletedSCPName} ?</h4>
            <div className="popup_btn_container">
              <button className="yes_btn " onClick={deleteSCP}>
                YES
              </button>
              <button className="no_btn " onClick={handleCloseModal}>
                NO
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );

};

export default RM;

